import { render } from "./AdminFeedback.vue?vue&type=template&id=76ebdb39&scoped=true"
import script from "./AdminFeedback.vue?vue&type=script&lang=js"
export * from "./AdminFeedback.vue?vue&type=script&lang=js"

import "./AdminFeedback.vue?vue&type=style&index=0&id=76ebdb39&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ebdb39"]])

export default __exports__